import { ICollaborationMetadata } from '@cscglobal-tbs/collaboration-ui';
import { useCommentTitleGeneration } from './useCommentTitleGeneration';

export const useReportFieldCommentsMetadata = (
    reportId?: string,
    reportName?: string,
    reportRowNumber?: number,
    reportColumnName?: string,
    reportRowDescription?: string,
    reportColumnTitle?: string
): ICollaborationMetadata => {
    const { newConversationTitle } = useCommentTitleGeneration(reportId, reportRowNumber, reportRowDescription, reportColumnTitle);

    return {
        contextData: {
            reportId,
            reportName,
            reportRowNumber,
            reportColumnName,
            reportRowDescription,
            reportColumnTitle,
        },
        generateNewConversationTitle: () => newConversationTitle,
    };
};
